export default __webpack_public_path__ + "70ca030c52e888cbcdf0ad88f5bcacb2.png";